// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"fa2cb08c","453":"8cb05881"}[chunkId] + ".chunk.js";
};